import type { CSSProperties, ReactNode } from "react";
import { T } from "../tokens";

export interface MonoDataProps {
  children: ReactNode;
  color?: string;
  size?: number;
  style?: CSSProperties;
}

// Day 13 mobile readability guideline: never call this with size < 11.
// See MonoLabel.tsx for the reasoning.
export function MonoData({
  children,
  color = T.ink500,
  size = 15,
  style,
}: MonoDataProps) {
  return (
    <span
      style={{
        fontFamily: T.mono,
        // 2026-05-30 可讀性下限:資料 / 數值不小於 12px。見 Han.tsx。
        fontSize: Math.max(size, 12),
        letterSpacing: "0.10em",
        color,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
